import React, {useState, useRef} from 'react';
import {Link} from "react-router-dom";

const Header = ({handleMenuClick, topRef, menuOpen, toggleMenu}) => {
  
  return(
    <header ref={topRef}>
      <div className="content">
          <img id="headerLogo" src="images/logo.png"/>
          <img id="hamburger" src="images/icons/hamburger.png" style={{display: menuOpen ?  'none' : 'block'}} onClick={toggleMenu}/>
          <img id="close" src="images/icons/close.png" style={{display: menuOpen ? 'block' : 'none'}} onClick={toggleMenu}/>
      </div>
        
      <nav style={{visibility: menuOpen ? 'visible' : ''}}>
        <ul id="links" onClick={handleMenuClick}>
          <li><Link to="/" id="home">HOME</Link></li>
          <li><Link to="/portfolio" id="portfolio">PORTFOLIO</Link></li>
          <li><Link to="/contact" id="contact">CONTACT ME</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;